var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collection-card",
      attrs: {
        onclick:
          "this.__vue__.playPause(+this.parentElement.getAttribute('data-swiper-slide-index'));"
      }
    },
    [
      _c("div", {
        class: [
          "collection-card__audio-status",
          _vm.isPlay
            ? "collection-card__audio-play"
            : "collection-card__audio-pause"
        ]
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "collection-card__image swiper-lazy",
        attrs: { "data-src": _vm.image, alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-lazy-preloader" }),
      _vm._v(" "),
      _c("div", { staticClass: "collection-card__title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }